import { IAppState } from '../../../AppModulesWrapper';
import { selectIsPackagesAvailable } from '../../reducers/v2/publicationPackages/selectors';

export const selectIsPublicationWrapperVisible = (state: IAppState): boolean => {
  const { isVisibleWithoutPackages } = state.servicePickerWidget.elementsVisibility.publicationWrapper;

  if (isVisibleWithoutPackages) {
    return true;
  }

  return selectIsPackagesAvailable(state);
};
